import { storeToRefs } from 'pinia';
import {
  useAgentStatusSettingsStore,
  useAgentStatusSettingsSetters,
} from './use-agent-status-settings-store';
import { useAgentStatusSettingsActions } from './use-agent-status-settings-actions';

export const useAgentStatusSettings = () => {
  return {
    ...storeToRefs(useAgentStatusSettingsStore()),
    ...useAgentStatusSettingsSetters(),
    ...useAgentStatusSettingsActions(),
  };
};
